module.exports = __webpack_public_path__ + "img/icon_navigation.34e18574.svg";